
const PartnersHeader = () => {
  return (
    <section className="w-full bg-gradient-to-r from-brand-purple to-golden-orange text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold mb-8">
            Our Amazing Partners
          </h1>
          <p className="text-xl lg:text-2xl max-w-4xl mx-auto opacity-90 leading-relaxed">
            Bobo & Teedee® is proud to collaborate with outstanding organizations that share our commitment to education, culture, and community development in the Cayman Islands.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnersHeader;
